<template>
    <b-form-group :class="buttonBlockClass">
        <b-button v-if="previous" type="button" variant="text" class="float-left" @click="previous">
            {{previousLabel || $t('tests.wizard.back')}}
        </b-button>
        <b-button type="button" variant="primary" class="float-right" @click="next"
                  :disabled="isButtonDisabled">
            {{nextLabel || $t('tests.wizard.next_step')}}
            <em class="icon-arrow-btn"></em>
        </b-button>
    </b-form-group>

</template>

<script>
    export default {
        name: 'tests-wizard-buttons-block',
        props: {
            isButtonDisabled: Boolean,
            next: Function,
            previous: Function,
            buttonBlockClass: '',
            nextLabel: {
                type: String,
                required: false
            },
            previousLabel: {
                type: String,
                required: false
            }

        }
    }
</script>

<style scoped>

</style>